var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "pb-2",
    attrs: {
      "flat": "",
      "rounded": "",
      "color": _vm.color
    }
  }, [_c('v-card-text', [_c('div', {
    staticClass: "mb-1 mt-n2 d-flex align-center"
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-chart-timeline-variant")]), _c('b', [_vm._v(_vm._s(_vm.$t("common.nouns.timeLine")))]), _c('v-spacer'), _c('a', {
    staticClass: "timeline-link",
    on: {
      "click": function click($event) {
        _vm.isSideCard = true;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("showAll")))])], 1), _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('v-avatar', {
    attrs: {
      "color": "black",
      "size": "24"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "small": ""
    }
  }, [_vm._v("mdi-dots-horizontal")])], 1)], 1), _vm.currentStatusMinusTwo ? _c('v-divider', {
    staticClass: "divider"
  }) : _vm._e(), _vm.currentStatusMinusTwo ? _c('div', {
    staticClass: "step d-none d-sm-flex"
  }, [_c('v-avatar', {
    attrs: {
      "color": "black",
      "size": "24"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "small": ""
    }
  }, [_vm._v("mdi-check-circle-outline")])], 1), _c('span', {
    staticClass: "step-label"
  }, [_vm._v(_vm._s(_vm.currentStatusMinusTwo))])], 1) : _vm._e(), _vm.currentStatusMinusOne ? _c('v-divider', {
    staticClass: "divider d-none d-sm-flex"
  }) : _vm._e(), _vm.currentStatusMinusOne && _vm.$vuetify.breakpoint.smAndUp ? _c('div', {
    staticClass: "step"
  }, [_c('v-avatar', {
    attrs: {
      "color": "black",
      "size": "24"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "small": ""
    }
  }, [_vm._v("mdi-check-circle-outline")])], 1), _c('span', {
    staticClass: "step-label"
  }, [_vm._v(_vm._s(_vm.currentStatusMinusOne))])], 1) : _vm._e(), _vm.currentStatus && _vm.$vuetify.breakpoint.smAndUp ? _c('v-divider', {
    staticClass: "divider"
  }) : _vm._e(), _vm.currentStatus ? _c('div', {
    staticClass: "step"
  }, [_c('v-avatar', {
    attrs: {
      "color": "primary",
      "size": "24"
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "small": ""
    }
  }, [_vm._v("mdi-circle-outline")])], 1), _c('span', {
    staticClass: "step-label primary--text"
  }, [_vm._v(_vm._s(_vm.currentStatus))])], 1) : _vm._e(), _c('v-divider', {
    staticClass: "divider primary-divider"
  }), _c('div', {
    staticClass: "step"
  }, [_c('v-btn', {
    attrs: {
      "outlined": "",
      "fab": "",
      "color": "primary",
      "height": "24",
      "width": "24"
    },
    on: {
      "click": function click($event) {
        _vm.dialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)], 1)]), _c('partner-report-status-history-add-dialog', {
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }), _vm.isSideCard ? _c('side-card', {
    attrs: {
      "title": _vm.$t('common.nouns.timeLine'),
      "width": "800px",
      "absolute": true
    },
    on: {
      "close": function close($event) {
        _vm.isSideCard = false;
      }
    }
  }, [_c('v-timeline', {
    attrs: {
      "dense": "",
      "clipped": "",
      "align-top": ""
    }
  }, _vm._l(_vm.statusHistory, function (status, i) {
    return _c('v-timeline-item', {
      key: i,
      attrs: {
        "small": "",
        "fill-dot": "",
        "color": _vm.iconColor(i)
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function fn() {
          return [i === 0 ? _c('v-icon', {
            attrs: {
              "small": "",
              "dark": ""
            }
          }, [_vm._v("mdi-circle-outline")]) : _c('v-icon', {
            attrs: {
              "small": "",
              "dark": ""
            }
          }, [_vm._v("mdi-check-circle-outline")])];
        },
        proxy: true
      }], null, true)
    }, [_c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-space-between align-start"
    }, [_c('div', {
      staticClass: "text-subtitle-2"
    }, [_c('span', {
      class: _vm.statusColorClass(i)
    }, [_vm._v(" " + _vm._s(status.status) + " ")])]), _c('div', {
      staticClass: "text-body-2 text-right"
    }, [_c('span', {
      staticClass: "mx-2",
      class: _vm.statusColorClass(i)
    }, [_vm._v(" " + _vm._s(_vm.formatDetailedDate(status.created)) + " ")]), _c('v-btn', {
      attrs: {
        "x-small": "",
        "icon": ""
      },
      on: {
        "click": function click($event) {
          return _vm.startDeleteStatus(i);
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-delete-outline")])], 1)], 1)]), _c('div', {
      staticClass: "text-body-2"
    }, [_vm._v(" " + _vm._s(status.message) + " ")])])], 1)], 1);
  }), 1)], 1) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t('delete'),
      "isDialogActive": _vm.isDeleteDialog,
      "rightDisabled": false,
      "rightLoading": _vm.isDeleteLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDeleteDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDeleteDialog = $event;
      },
      "rightClick": _vm.deleteStatus,
      "leftClick": function leftClick($event) {
        _vm.isDeleteDialog = false;
      }
    }
  }, [_vm.deleteIndex !== null && _vm.deleteIndex !== undefined && _vm.statusHistory[_vm.deleteIndex] ? _c('span', [_vm._v(" " + _vm._s(_vm.statusHistory[_vm.deleteIndex].status) + " (" + _vm._s(_vm.formatDetailedDate(_vm.statusHistory[_vm.deleteIndex].created)) + ") ")]) : _vm._e()])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }